import { GxBigCalendarEventPropGetter } from "@/components/molecules/GxBigCalendar";
import {
  ChargePlansColorType,
  EventBgColor,
  EventFontColor,
} from "@/models/chargePlans";
import { getJSTTime } from "@/util/datetime";

export const ChargePlansConstants = {
  ChargePlans: "充電計画",
  OfficeName: "会社／営業所",
  RadioNumber: "無線番号",
  SoC: "SoC",
} as const;

export const SOC_COLORS: ChargePlansColorType[] = [
  "soc_history",
  "soc_forecast",
];

const colorMap: Readonly<{
  [key in ChargePlansColorType]: Readonly<[EventBgColor, EventFontColor]>;
}> = {
  schedule: ["skyblue", "black"],
  rest: ["grey", "black"],
  quick: ["lime", "black"],
  quick_other: ["orange", "black"],
  standard: ["blue", "white"],
  emp: ["red", "white"],
  public: ["#0e8f79aa", "white"],
  status_quick: ["purple", "white"],
  supply_quick: ["purple", "white"],
  status_quick_other: ["navy", "white"],
  supply_quick_other: ["navy", "white"],
  status_standard: ["darkcyan", "white"],
  supply_standard: ["darkcyan", "white"],
  soc_history: ["#00FA9AAA", "black"],
  soc_forecast: ["#FFD700AA", "black"],
};

const editTimeRange = (
  color: ChargePlansColorType,
  start: string | Date,
  end: string | Date,
  titleName?: string
) => {
  const startStr = getJSTTime(new Date(start), "datetime").slice(11, 16);
  const endStr = getJSTTime(new Date(end), "datetime").slice(11, 16);

  if (color.includes("status")) {
    return `実績 ${startStr} – (充電中)`;
  }

  if (color.includes("supply")) {
    return `実績 ${startStr} – ${endStr}`;
  }

  if (
    color === "quick" ||
    color === "quick_other" ||
    color === "standard"
  ) {
    return `予約 ${startStr} – ${endStr}`;
  }

  if (color === "public" || color === "emp") {
    return `予定 ${startStr} – ${endStr}`;
  }

  if (SOC_COLORS.includes(color)) {
    return `${titleName}`;
  }

  return undefined;
};

export const chargePlansEventPropGetter: GxBigCalendarEventPropGetter<
  ChargePlansColorType
> = ({ color, start, end, titleName }) => ({
  backgroundColor: colorMap[color][0],
  fontColor: colorMap[color][1],
  customEventTimeRange: editTimeRange(color, start, end, titleName),
});

export const IGNORE_COLOR: ChargePlansColorType[] = [
  "status_standard",
  "supply_standard",
];
